import { gql } from '../../../apollo/__generated__';

export const EVENT_OPTIONS = gql(`
  query EventOptions {
    events {
      id
      name
    }
  }
`);
